// Port of api/fuel/app/classes/insights/size/summary.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function monthStartOffset(monthOffset) {
	var date = new Date()
	date.setUTCDate(1)
	date.setUTCHours(0, 0, 0, 0)
	date.setUTCMonth(date.getUTCMonth() + monthOffset)
	return Math.floor(date.getTime() / 1000)
}

function monthStampOffset(monthOffset) {
	var date = new Date(monthStartOffset(monthOffset) * 1000)
	var month = String(date.getUTCMonth() + 1)
	if (month.length < 2) month = '0' + month
	return month + '.' + String(date.getUTCFullYear()).slice(-2)
}

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

export default Segment.extend({
	name: 'summary',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var field = excludeExpansions(vars && vars.sessionUserId) ? 'insight_count_base' : 'insight_count'
		var summary = {
			total: {
				current: false,
				'1m': false,
				'3m': false,
				'6m': false,
				'1y': false,
				'2y': false,
				'3y': false
			}
		}
		var keys = ['current', '1m', '3m', '6m', '1y', '2y', '3y']
		var stamps = [
			monthStampOffset(0),
			monthStampOffset(-1),
			monthStampOffset(-3),
			monthStampOffset(-6),
			monthStampOffset(-12),
			monthStampOffset(-24),
			monthStampOffset(-36)
		]
		var rows = Util.queryFast(
			'SELECT insight_stamp, ' + field + ' AS v FROM insight_user_collection' +
			' WHERE user_id = ' + owner.get_id() +
			' AND insight_stamp IN(' + stamps.map(function(stamp) { return '"' + stamp + '"' }).join(',') + ')' +
			' ORDER BY insight_date DESC'
		)

		for (var i = 0; i < rows.length && i < keys.length; i++) {
			summary.total[keys[i]] = i > 0
				? (parseInt(rows[0].v, 10) || 0) - (parseInt(rows[i].v, 10) || 0)
				: (parseInt(rows[i].v, 10) || 0)
		}

		return {
			summary: summary
		}
	}
})
